import React, {FC, FormEvent, useMemo} from "react";
import Button from "../button";
import * as constants from "../../../constants/fixture.constants";

import styles from "./editorTrimControls.module.scss";
import useEditorAngles from "../../../store/editorAngles/useEditorAngles";

export interface EditorTrimControlsProps {
    onCancel: (event: FormEvent<EventTarget>) => void;
    onSave: (event: FormEvent<EventTarget>) => void;
}

const EditorTrimControls: FC<EditorTrimControlsProps> = ({ onCancel, onSave }) => {
    const { selectedAngles, anglesAudio } = useEditorAngles();


    const areAllSelectedAnglesDifferent = useMemo(() => {
        if (anglesAudio.length === 0) {
            return true;
        }
        const uniqueAngles = new Set(anglesAudio.map(angle => `${angle.commonAngleId}-${angle.audioTrackId}`));
        return uniqueAngles.size === selectedAngles.length;
    }, [anglesAudio, selectedAngles.length]);

    const emptyAngles = useMemo(() => {
        return selectedAngles.length === 0;
    }, [selectedAngles])

    const invalidAngles = useMemo(() => {
        return emptyAngles || !areAllSelectedAnglesDifferent;
    }, [emptyAngles, areAllSelectedAnglesDifferent]);

    const saveButtonStyles = useMemo(() => {
        return invalidAngles ? `btn-green ${styles.saveButton}` : "btn-green"
    }, [invalidAngles])

    const tooltipToDisplay = useMemo(() => {
        if (emptyAngles && !areAllSelectedAnglesDifferent) {
            return constants.TRIM_NO_ANGLES_SELECTED_AND_NOT_DIFFERENT;
        }

        if (emptyAngles) {
            return constants.TRIM_NO_ANGLES_SELECTED;
        }

        if (!areAllSelectedAnglesDifferent) {
            return constants.TRIM_ANGLES_NOT_DIFFERENT;
        }

        return constants.SAVE;
    }, [emptyAngles, areAllSelectedAnglesDifferent]);


    return (
        <div className={styles.editorSave}>
            <Button name={constants.CANCEL} tooltip={constants.CANCEL} classes={"btn-green"} onClick={onCancel}/>
            <Button name={constants.SAVE} tooltip={tooltipToDisplay} classes={saveButtonStyles} onClick={onSave}  disabled={invalidAngles}/>
        </div>
    );
};

export default EditorTrimControls;
